// src/data/gyms/TopTier.js
export const TopTier = {
  id: "toptier",
  name: "Top Tier Elite",
  color: "#BE123C", // Rich Ruby
  lightColor: "#FFF1F2",
  logo: "💎",

  teams: [
    {
      id: "crystalcrush",
      name: "Crystal Crush",
      level: "L1 Junior - Flex - D2",
    },
    { id: "eliteemeralds", name: "Elite Emeralds", level: "L2 Senior - D2" },
    { id: "diamonds", name: "Diamonds", level: "L2 Junior - D2 - Small" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "11:21 AM",
      teamId: "diamonds",
      meet: "10:45 AM",
      panel: "Hall B",
    },
    // Found missing Saturday time for Elite Emeralds (Row 63)
    {
      day: "Saturday",
      time: "12:10 PM",
      teamId: "eliteemeralds",
      meet: "11:34 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:05 PM",
      teamId: "crystalcrush",
      meet: "1:29 PM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:24 AM",
      teamId: "diamonds",
      meet: "8:48 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "10:13 AM",
      teamId: "eliteemeralds",
      meet: "9:37 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "11:46 AM",
      teamId: "crystalcrush",
      meet: "11:10 AM",
      panel: "Hall A",
    },
  ],
};
